// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Steam_container__9lVtD {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 {
  width: 50%;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_back__9wtSC {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #EAD40C;
  cursor: pointer;
  display: flex;
  gap: 16px;
  margin-bottom: 25px;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 32px 20px;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_title__RAnzg {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: center;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_info__3YG4e {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  line-height: 120%;
  margin: 0 auto;
  text-align: center;
  width: 85%;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_btns__Mq47C {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_btns__Mq47C .Steam_btn__ooJDP button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #EAD40C;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 46px;
  padding-left: 22px;
  padding-right: 22px;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_skipInfo__yQXQt {
  color: rgba(224, 224, 224, 0.8);
  margin-top: 60px;
  text-align: center;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_skipBtn__kK9Ax {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_skipBtn__kK9Ax button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #333217;
  border-radius: 8px;
  color: #EAD40C;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 46px;
  padding-left: 22px;
  padding-right: 22px;
}

@media (max-width: 850px) {
  .Steam_container__9lVtD {
    height: unset;
    padding-bottom: 100px;
    padding-top: 104px;
  }
  .Steam_container__9lVtD .Steam_wrapper__gLqd9 {
    width: 90%;
  }
  .Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o {
    padding: 20px 14px;
  }
  .Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_title__RAnzg {
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
  }
  .Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_info__3YG4e {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    width: 100%;
  }
  .Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_btns__Mq47C {
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
  }
  .Steam_container__9lVtD .Steam_wrapper__gLqd9 .Steam_steam__Xmf9o .Steam_btns__Mq47C .Steam_btn__ooJDP button {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    height: 36px;
    padding: 6px 16px;
    width: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/Steam/Steam.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;AADF;AAGE;EACE,UAAA;AADJ;AAGI;ECsCF,eAAA;EACA,gBAAA;EACA,kBAAA;EDrCI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAGI;EACE,oCAAA;EACA,kBAAA;EACA,kBAAA;AADN;AAGM;ECpBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDqBM,cE9BE;EF+BF,mBAAA;EACA,kBAAA;AAAR;AAGM;ECQJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDPM,cEhCO;EFiCP,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAAR;AAGM;ECRJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDSM,aAAA;EACA,uBAAA;EACA,gBAAA;AAAR;AAIU;ECLR,eAAA;EACA,gBAAA;EACA,kBAAA;EDMU,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AADZ;AAMM;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;AAJR;AAQI;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AANN;AAQM;ECjCJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDkCM,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AALR;;AAWA;EACE;IACE,aAAA;IACA,qBAAA;IACA,kBAAA;EARF;EAUE;IACE,UAAA;EARJ;EAUI;IACE,kBAAA;EARN;EAUM;ICnGN,eAAA;IACA,gBAAA;IACA,kBAAA;ED4FA;EASM;ICvDN,eAAA;IACA,gBAAA;IACA,kBAAA;IDwDQ,WAAA;EANR;EASM;ICzEN,eAAA;IACA,gBAAA;IACA,kBAAA;EDmEA;EASU;ICxEV,eAAA;IACA,gBAAA;IACA,kBAAA;IDyEY,YAAA;IACA,iBAAA;IACA,YAAA;EANZ;AACF","sourcesContent":["@import '../../../assets/styles/global.scss';\n\n.container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n\n  .wrapper {\n    width: 50%;\n    \n    .back {\n      @include subtitle6m;\n\n      align-items: center;\n      color: #EAD40C;\n      cursor: pointer;\n      display: flex;\n      gap: 16px;\n      margin-bottom: 25px;\n    }\n\n    .steam {\n      background-color: rgba(0, 0, 0, .3);\n      border-radius: 8px;\n      padding: 32px 20px;\n\n      .title {\n        @include h2;\n\n        color: $c-white;\n        margin-bottom: 20px;\n        text-align: center;\n      }\n\n      .info {\n        @include subtitle5;\n\n        color: $c-light-grey;\n        line-height: 120%;\n        margin: 0 auto;\n        text-align: center;\n        width: 85%;\n      }\n\n      .btns {\n        @include subtitle4m;\n\n        display: flex;\n        justify-content: center;\n        margin-top: 24px;\n\n        .btn {\n\n          button {\n            @include subtitle6m;\n      \n            align-items: center;\n            background-color: #EAD40C;\n            border-radius: 8px;\n            cursor: pointer;\n            display: flex;\n            gap: 8px;\n            height: 46px;\n            padding-left: 22px;\n            padding-right: 22px;\n          }\n        }\n      }\n\n      .skipInfo {\n        color: rgba(224, 224, 224, .8);\n        margin-top: 60px;\n        text-align: center;\n      }\n    }\n\n    .skipBtn {\n      display: flex;\n      justify-content: flex-end;\n      margin-top: 24px;\n\n      button {\n        @include subtitle6m;\n\n        align-items: center;\n        background-color: #333217;\n        border-radius: 8px;\n        color: #EAD40C;\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        height: 46px;\n        padding-left: 22px;\n        padding-right: 22px;\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    height: unset;\n    padding-bottom: 100px;\n    padding-top: 104px;\n\n    .wrapper {\n      width: 90%;\n\n      .steam {\n        padding: 20px 14px;\n\n        .title {\n          @include h3;\n        }\n\n        .info {\n          @include body1;\n\n          width: 100%;\n        }\n\n        .btns {\n          @include subtitle6m;\n\n          .btn {\n\n            button {\n              @include subtitle7m;\n\n              height: 36px;\n              padding: 6px 16px;\n              width: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Steam_container__9lVtD`,
	"wrapper": `Steam_wrapper__gLqd9`,
	"back": `Steam_back__9wtSC`,
	"steam": `Steam_steam__Xmf9o`,
	"title": `Steam_title__RAnzg`,
	"info": `Steam_info__3YG4e`,
	"btns": `Steam_btns__Mq47C`,
	"btn": `Steam_btn__ooJDP`,
	"skipInfo": `Steam_skipInfo__yQXQt`,
	"skipBtn": `Steam_skipBtn__kK9Ax`
};
export default ___CSS_LOADER_EXPORT___;
